import { createSelector } from '@ngrx/store';
import { selectAllOperations } from './entity-store-selectors';

export function selectOperationById(operationId: string) {
  return createSelector(selectAllOperations, (operations) => {
    return operations.get(operationId);
  });
}

export function selectActiveOperationByUnitId(unitId: string) {
  return createSelector(selectAllOperations, (operations) => {
    return operations.valueSeq().find((o) => o.unitId === unitId && o.dateOperationEnded == null);
  });
}
